module.exports = __webpack_public_path__ + "static/iso_11.c7b30e97.png";